<template>
	<div class="container">
		<div class="cloud-wrap userinfo-cnt">
			<div class="cloud-cnt" v-if="status==''">
				<div class="cloud-form">
					<span class="cloud-item">选择CPU架构</span>
					<el-select v-model="frameworkId" placeholder="请选择CPU架构" @change="selectChange">
						<el-option
						v-for="item in cloudList"
						:key="item.id"
						:label="item.frameworkName"
						:value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="cloud-form cloud-form2">
					<span class="cloud-item">申请描述</span>
					<textarea v-model="content" class="cloud-content" placeholder="请输入申请描述!"></textarea>
				</div>
				<div class="cloud-form cloud-form3">
					<span class="cloud-item">云资源申请说明 :</span>
					<div class="cloud-explain" v-html="cloudResourceExplain"></div>
				</div>
				<div class="submit-btn" @click="submitCloud">提交申请</div>
			</div>
			<div class="cloud-cnt" v-if="status==3">
				<div class="status">
					<img class="status-img" src="@/assets/success_icon.png"/>
					<p>审核中，申请成功后将会在此反馈云适配资源账号信息</p>
				</div>
			</div>
			<div class="cloud-cnt" v-if="status==4">
				<div class="status">
					<img class="status-img" src="@/assets/fail_icon.png"/>
					<p>抱歉，您的申请未通过</p>
					<div v-if="statusEntity.auditComment" class="audit-comment">审核意见：{{statusEntity.auditComment}}</div>
					<div class="submit-btn" @click="submitAgain">再次提交申请</div>
				</div>
			</div>
			<div class="cloud-cnt" v-if="status==5">
				<div class="status-success">
					<p class="status-success-top">申请通过，您的云资源适配账号信息如下：</p>
					<div class="account-info">
						<div class="account-info-list"><span>账号：</span><p>{{statusEntity.account}}</p></div>
						<div class="account-info-list"><span>密码：</span><p>{{statusEntity.password}}</p></div>
						<div class="account-info-list"><span>虚拟机内部IP：</span><p>{{statusEntity.machineIp}}</p></div>
						<div class="account-info-list"><span>映射IP：</span><p>{{statusEntity.mappingIp}}</p></div>
						<div class="account-info-list"><span>VNC访问端口：</span><p>{{statusEntity.vncPort}}</p></div>
						<div class="account-info-list"><span>WinSCP访问端口：</span><p>{{statusEntity.winscpPort}}</p></div>
						<div class="account-info-list"><span>审核意见：</span><p>{{statusEntity.auditComment}}</p></div>
					</div>
				</div>
			</div>
			<div class="cloud-img">
				<img src="@/assets/cloud_01.png" />
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post, ajaxParam } from '@/units/request.js'
export default {
  name: 'CloudResourse',
  components: {
    
  },
  data(){
	return {
		userId: '',
		activityId: '',
		cloudList: [],
		searchKeyWord: '',
		frameworkId: '',
		status: '', //3审核中  4不通过  5通过
		statusEntity: {},
		content: '',  //申请描述
		cloudResourceExplain: ''
	}
  },
  methods: {
	//获取用户最新提交记录
	async getUserCloud(){
		let url = 'v1/cloudResource/getUserCloudResourceRecord'
		let param = {
			activityId: this.activityId,
			userId:  this.userId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			let entity = res.data.entity
			if(entity) {
				this.status = entity.status
				this.statusEntity = entity
			}
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//获取CPU架构列表
	async getCloundList(){
		let url = 'v1/cloudResource/getCloudResourceFramework'
		let param = {
			activityId: this.activityId,
			searchKeyWord: this.searchKeyWord
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.cloudList = res.data.list
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//选择CPU架构
	selectChange(e){
		this.frameworkId = e
	},
	//提交云申请
	async submitCloud(){
		if(this.frameworkId=='') {
			this.$message.error('请选择CPU架构！')
			return
		}
		if(this.content=='') {
			this.$message.error('请输入申请描述！')
			return
		}
		let url = 'v1/cloudResource/submitApply'
		let param = {
			activityId: this.activityId,
			frameworkId: this.frameworkId,
			userId:  this.userId,
			content: this.content
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.status = 3
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//获取活动信息
	async getActiveInfo(){
		let url = 'v1/activity/getIndexActivity'
		let param = {}
		const res = await post(url, param)
		if(res.data.code==200) {
			let entity = res.data.entity
			this.activityId = entity.id
			this.cloudResourceExplain = entity.cloudResourceExplain
			this.getCloundList()
			this.getUserCloud()
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//审核失败再次提交
	submitAgain(){
		this.status = ''
	}
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.getActiveInfo()
  }
}
</script>

<style scoped>
	.userinfo-cnt{
		float: right;
		width: 88%;
		min-height: 300px;
		box-sizing: border-box;
	}
	.cloud-wrap{
		display: flex;
		justify-content: space-between;
		padding-right: 5%;
		padding-top: 100px
	}
	.cloud-cnt{
		width: 460px;
		font-size: 13px;
	}
	.cloud-form{display: flex;  align-items: center; margin-bottom: 20px;}
	.cloud-form2{align-items: flex-start;}
	.cloud-item{width: 100px; margin-right: 14px; text-align: right;}
	.cloud-form input.el-input__inner{width: 220px; height: 32px;}
	.cloud-content{ width: 260px; min-height: 80px; padding:5px 15px; box-sizing: border-box; border: 1px solid #DCDFE6; border-radius: 4px;}
	.cloud-content::-webkit-input-placeholder{
		color: #c0c4cc;
	}
	.el-input__icon{line-height: 32px;}
	.submit-btn{
		width: 95px;
		height: 20px;
		margin: 90px auto;
		background: #DE0515;
		color: #fff;
		font-weight: bold;
		line-height: 20px;
		text-align: center;
		font-size: 11px;
		cursor: pointer;
	}
	.cloud-img img {
		width: 375px;
		height: 328px;
		margin-top: -30px;
	}
	.status{
		text-align: center;
	}
	.status-img{
		width: 38px;
		height: 38px;
		margin-bottom: 25px;
	}
	.status-success{
		color: #000;
		font-size: 13px;
	}
	.status-success-top{
		font-weight: bold;
	}
	.account-info{
		width: 80%;
		margin-top: 20px;
		padding: 10px;
		background: #FFF7DD;
		line-height: 24px;
		font-size: 32rpx;
	}
	.account-info-list{display: flex;}
	.account-info-list span{width: 120px; margin-right:5px; text-align: right;}
	.account-info-list p {flex:1; word-wrap: break-word; word-break: break-all;}
	.audit-comment{
		margin-top: 20px;
		font-size: 11px;
	}
	.cloud-form3{
		display: flex;
		align-items: flex-start;
	}
	.cloud-explain{
		width: 260px;
		display: flex;
		flex-direction: column;
	}
</style>
